<template>
  <div>
    <div v-if="$apollo.loading" class="content">
      <Loader label="Loading Campaign..." />
    </div>

    <div v-if="!$apollo.loading" class="text-center">
      <div class="content">
        <Error
          v-if="!$apollo.loading && errors.length"
          message="It looks like we couldn't send your campaign. Please try again."
          :errors="errors"
          :error-action="onSendClick"
          error-action-label="Retry?"
          class="mb-8 md:mb-10 md:mt-2 max-w-md mx-auto"
        />

        <div class="icon-wrap">
          <v-icon name="rocket" scale="2.5" class="send-icon v-center" />
        </div>

        <h1 class="text-center text-lg sm:text-3xl mb-12">
          Send Newsletter
        </h1>

        <SendCampaignStats
          :subscriber-count="details.subscriberCount"
          :campaigns-sent-this-month="details.campaignsSentThisMonth"
          :emails-sent-this-month="details.emailsSentThisMonth"
        />

        <SendCampaignAlerts
          :subscriber-count="details.subscriberCount"
          :send-campaign-failed="campaignCheck.sendCampaignFailed"
          :next-send-at="campaignCheck.nextSendAt"
        />
      </div>

      <SendCampaignActions
        :disable-download="loading"
        :disable-send="disableSend"
        :campaign-sending="campaignSending"
        :campaign-id="campaignId"
        @send-click="onSendClick"
      />
    </div>
  </div>
</template>

<script>
import { SendCampaign as SendCampaignMutation } from "@/graphql/mutations";
import SendCampaignStats from "@/components/Campaigns/SendCampaign/SendCampaignStats";
import SendCampaignAlerts from "@/components/Campaigns/SendCampaign/SendCampaignAlerts";
import SendCampaignActions from "@/components/Campaigns/SendCampaign/SendCampaignActions";
import Error from "@/components/UI/Error";
import Loader from "@/components/UI/Loader";
import { getAccountId } from "@/lib/auth";

export default {
  name: "SendCampaign",
  components: {
    Error,
    Loader,
    SendCampaignActions,
    SendCampaignAlerts,
    SendCampaignStats,
  },
  props: {
    campaignCheck: {
      default: () => {},
      type: Object,
    },
    campaignId: {
      required: true,
      type: String,
    },
    details: {
      default: () => ({
        campaignsSentThisMonth: 0,
        subscriberCount: 0,
        customerCount: 0,
      }),
      type: Object,
    },
  },
  data() {
    return {
      campaignSending: false,
      errors: [],
      loading: false,
      upgradeSuccessful: false,
    };
  },
  computed: {
    disableSend() {
      if (this.loading) return true;

      if (!this.details.subscriberCount) return true;

      if (this.campaignCheck.sendCampaignFailed) return true;

      return false;
    },
  },
  methods: {
    onSendClick: async function() {
      this.loading = true;
      this.campaignSending = true;
      this.resetErrors();

      try {
        const result = await this.$apollo.mutate({
          mutation: SendCampaignMutation,
          variables: {
            input: {
              campaignId: this.campaignId,
            },
          },
        });

        this.loading = false;
        this.campaignSending = false;

        const campaignSent = result.data?.sendCampaign?.sent;

        if (campaignSent) {
          this.$gtm.trackEvent({
            event: "promo-campaign-sent",
            stage: process.env.VUE_APP_ENV,
            accountId: getAccountId(),
            campaignId: this.campaignId,
          });

          this.$router.push({
            name: "Campaigns",
            query: {
              campaignSent: this.campaignId,
            },
          });

          this.$modal.hide("send-campaign");
        } else {
          throw "Campaign could not be sent";
        }
      } catch (error) {
        console.log("error", error);
        this.errors.push(error);
        this.loading = false;
        this.campaignSending = false;
      }
    },
    resetErrors() {
      this.errors = [];
    },
  },
};
</script>

<style scoped>
.content {
  @apply p-2;

  @screen md {
    @apply p-8;
  }
}

.send-icon {
  @apply text-brand;
}
</style>
